import i18n from "dev/lang";

function $t(key) {
	return i18n.t(key);
}
export default [
	$t("cancelReasons.noAnswering"),
	// $t("cancelReasons.pleaseCallOffice"),
	$t("cancelReasons.alotOfGear"),
	$t("cancelReasons.survereyNotFound"),
	$t("cancelReasons.notReadyToSurveyScaffolding"),
	$t("cancelReasons.waitForLoweringAc"),
	$t("cancelReasons.sewageNotClosed"),
	$t("cancelReasons.wallNotFoundInNisa"),
	$t("cancelReasons.plugNotFound"),
	$t("cancelReasons.customerCanceled"),
	$t("cancelReasons.customerReject"),
	$t("cancelReasons.customerNotFound"),
	$t("cancelReasons.rejectToTommorow"),
	$t("cancelReasons.customerNotAnswer"),
	"המודד לא הספיק למדוד היות היו מדידות שהתארכו מהזמן הרגיל - נתאם מחדש",
	// 	// this.$t("cancelReasons.pleaseCallOffice"),
	"האתר נסגר",
	"אחר",
	"שטח לא מוכן"
];
